<template>
  <div class="course-card">
    <div class="tags">
      <div class="tag on" v-if="content.status === 1">
        <span>已发布</span>
      </div>
      <div class="tag off" v-if="content.status === 0">
        <span>未发布</span>
      </div>
    </div>
    <div class="sorts">
      <el-button circle size="mini" icon="el-icon-back" :disabled="noUp" title="排序前" @click="handleSortChange(content, 'up')"></el-button>
      <el-button circle size="mini" icon="el-icon-right" :disabled="noDown" title="排序后" @click="handleSortChange(content, 'down')"></el-button>
    </div>
    <img :src="content.picture_url" />
    <div class="content-wrap">
      <p class="title">{{content.name}}</p>
      <div class="old-price">¥{{content.market_price}}</div>
      <div class="count">
        <div class="new-price">¥{{content.price}}</div>
      </div>
    </div>
    <div class="item-footer">
      <span class="subject-name" :title="(content.subjects && content.subjects.length) ? content.subjects[0].name : ''">{{(content.subjects && content.subjects.length) ? content.subjects[0].name : ''}}</span>
      <span class="member-count">{{content.user_count}}人购买</span>
    </div>
    <div class="menu">
      <div class="menu-item">
        <router-link :to="`/course/detail/${content.id}`">
          <i class="el-icon-edit"></i>
          <span>编辑</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToPreview">
        <i class="el-icon-zoom-in"></i>
        <span>浏览</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handelCourseRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "course-card",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    noUp: false,
    noDown: false
  },
  data() {
    return {};
  },
  methods: {
    handelCourseRemove() {
      this.$emit("remove", this.content.id);
    },
    // 预览
    handleToPreview() {
      if (this.content) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/course/detail/${this.content.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/course/detail/${this.content.id}`)
        }
      }
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      this.$emit('sort', row, sort)
    },
  }
};
</script>

<style lang="less" scoped>
.course-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;

  &:hover {
    .sorts {
      display: block;
    }
  }

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409eff;
      }
    }
  }

  img {
    width: 100%;
    height: 136px;
    object-fit: cover;
  }

  .sorts {
    display: none;
    position: absolute;
    right: 5px;
    top: 2px;

    button {
      padding: 2px;
    }
  }

  .content-wrap {
    display: flex;
    flex-direction: column;
    height: 85px;
    padding: 0 10px;

    .title {
      flex: 1;
      margin-top: 5px;
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .count {
      display: flex;
      justify-content: space-between;
    }
    .old-price {
      text-decoration: line-through;
      color: #999;
      margin-top: 10px;
    }
    .new-price {
      margin-top: 2px;
      color: #f00;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding: 0 10px;

    .subject-name {
      flex: 1;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .member-count {
      margin-left: 10px;
    }
  }
  a {
    text-decoration: none;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin-top: 10px;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
